import { createContext, useContext, useState, type ReactNode } from 'react'

export interface Steps {
  newProcedureStep: number
  chipValidationError: boolean
  signatureStep: number
  savedDocument: boolean
  success: boolean
  inProcess: boolean
  clearSearch: boolean
  setNewProcedureStep: React.Dispatch<React.SetStateAction<number>>
  setChipValidationError: React.Dispatch<React.SetStateAction<boolean>>
  setSignatureStep: React.Dispatch<React.SetStateAction<number>>
  setSavedDocument: React.Dispatch<React.SetStateAction<boolean>>
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>
  resetSteps: React.Dispatch<React.SetStateAction<boolean>>
  setInProcess: React.Dispatch<React.SetStateAction<boolean>>
  setClearSearch: React.Dispatch<React.SetStateAction<boolean>>
}

const StepsContext = createContext({
  newProcedureStep: 0,
  chipValidationError: false,
  savedDocument: false,
  success: false,
  inProcess: false,
  clearSearch: false,
  setNewProcedureStep: (param: any) => {},
  setChipValidationError: (param: any) => {},
  setSavedDocument: (param: any) => {},
  setSuccess: (param: any) => {},
  resetSteps: () => {},
  setInProcess: (param: any) => {},
  setClearSearch: (param: any) => {}
})

export const useStepsContext = () => useContext(StepsContext)

interface Props {
  children: ReactNode
}

export const StepsContextProvider = ({ children }: Props) => {
  const [newProcedureStep, setNewProcedureStep] = useState(1)
  const [chipValidationError, setChipValidationError] = useState(false) //	default: false
  const [savedDocument, setSavedDocument] = useState(false)
  const [success, setSuccess] = useState(false) //	default: false
  const [inProcess, setInProcess] = useState(false)
  const [clearSearch, setClearSearch] = useState(false)

  const resetSteps = () => {
    setNewProcedureStep(1)
    setChipValidationError(false)
    setSavedDocument(false)
    setSuccess(false)
    setClearSearch(false)
  }

  const contextValue = {
    newProcedureStep,
    chipValidationError,
    savedDocument,
    success,
    inProcess,
    clearSearch,
    setNewProcedureStep,
    setChipValidationError,
    setSavedDocument,
    setSuccess,
    resetSteps,
    setInProcess,
    setClearSearch
  }

  return <StepsContext.Provider value={contextValue}>{children}</StepsContext.Provider>
}

export default StepsContext
